import {IssuesGhostUser} from '@github-ui/server-persisted-queries'
import type {IssuesGhostUserQuery} from '@github-ui/server-persisted-queries/types/IssuesGhostUser'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

export type GhostUser = NonNullable<IssuesGhostUserQuery['user']>

export const GHOST_USER_QUERY_KEY = ['commenting', 'ghost-user'] as const

export async function fetchGhostUser(signal?: AbortSignal): Promise<GhostUser> {
  const response = await verifiedFetchJSON(`/issues/ghost-user?queryId=${IssuesGhostUser}`, {signal})
  if (!response.ok) {
    throw new Error(`Ghost user fetch failed (${response.status})`)
  }

  const json = (await response.json()) as {data?: IssuesGhostUserQuery; errors?: unknown[]}
  if (!json.data) {
    throw new Error('Ghost user query returned no data')
  }
  if (!json.data.user) {
    throw new Error('Ghost user not found')
  }

  return json.data.user
}
